import * as React from 'react';
export var IconInfoFill = React.forwardRef(function IconInfoFill({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5A.75.75 0 0 0 8 7Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-2.043a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm-.75 1.793a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0v-3.5Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-2.043a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm-.75 1.793a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0v-3.5Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
